import {
	BeamLayer,
	BrandNodeData,
	MobileBeamLabel,
	RevealCurtainAnimationConfig
} from '@/components/ServicesLobbyPage/BrandEvolutionSection/types';

export const BEAM_LAYERS: readonly BeamLayer[] = [
	{ id: '01', src: '/assets/images/brand-evolution-section/beam-01.svg' },
	{ id: '02', src: '/assets/images/brand-evolution-section/beam-02.svg' },
	{ id: '03', src: '/assets/images/brand-evolution-section/beam-03.svg' },
	{ id: '04', src: '/assets/images/brand-evolution-section/beam-04.svg' },
	{ id: '05', src: '/assets/images/brand-evolution-section/beam-05.svg' },
	{ id: '06', src: '/assets/images/brand-evolution-section/beam-06.svg' }
];

export const MOBILE_BEAM_LABELS: readonly MobileBeamLabel[] = [
	{ id: '01', text: 'Product Design' },
	{ id: '02', text: 'Branding' },
	{ id: '03', text: 'Digital Campaigns and Creative Marketing' },
	{ id: '04', text: 'Website Production' },
	{ id: '05', text: 'Video Production' },
	{ id: '06', text: 'Offline Event Experience' }
];

export const CURRENT_BRAND_NODE: BrandNodeData = {
	variant: 'current',
	title: 'Current brand',
	descriptionLines: ['Safe, soft-spoken,', 'easy to overlook'],
	media: {
		type: 'image',
		src: '/assets/images/white-flat-chub.webp',
		width: 85,
		height: 60,
		alt: ''
	}
};

export const NEW_BRAND_NODE: BrandNodeData = {
	variant: 'new',
	title: 'Brand 2.0',
	descriptionLines: ['Owns attention and', 'maximizes profit'],
	media: {
		type: 'video',
		sources: [
			{
				src: '/assets/video/mov/branding-page/green-chub.mov',
				type: 'video/quicktime; codecs="hvc1"'
			},
			{
				src: '/assets/video/webm/branding-page/green-chub.webm',
				type: 'video/webm'
			}
		]
	}
};

export const REVEAL_CURTAIN_ANIMATION: RevealCurtainAnimationConfig = {
	initialReveal: '-28%',
	finalReveal: '128%',
	duration: 3.5,
	ease: 'power2.out',
	scrollTriggerStart: 'top 80%'
};
